package one.healthium.log_weight.ui.internal

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.UserModel
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class LogWeightViewModel(
    private val userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(LogWeightUiState(isMetric = appPreferences.isMetric))
    val state = _state.asStateFlow()

    val uiMessage = UiMessageManager()
    val events = EventProducer<LogWeightEvents>()

    init {
        userInteractor.observeUser()
            .catch {
                // TODO
            }
            .onEach { user ->
                _state.update { state ->
                    state.copy(
                        latestWeightLog = user.toWeightUiModel(),
                        initialWeight = user.profile.weight ?: 0f,
                    )
                }
            }
            .launch()

        appPreferences.isMetricFlow
            .onEach { isMetric ->
                _state.update { state ->
                    state.copy(isMetric = isMetric)
                }
            }
            .launch()
    }

    fun onUpdateWeight(value: Float, taskId: String?) {
        val currentWeight = state.value.latestWeightLog?.currentWeight
        val startWeight = state.value.initialWeight
        val delta = startWeight - value
        if (currentWeight != value) {
            launch {
                _state.update { state -> state.copy(loading = true) }

                try {
                    userInteractor.addWeight(value, taskId)
                    events.trigger(LogWeightEvents.OnWeightAdded(delta = delta))
                } catch (e: Exception) {
                    Logger.e("update weight error", e)
                    uiMessage.add(UiMessage.throwable(e))
                } finally {
                    _state.update { state -> state.copy(loading = false) }
                }
            }
        } else {
            events.trigger(LogWeightEvents.OnWeightAdded(delta = 0f))
        }
    }
}

private fun UserModel.toWeightUiModel(
) = WeightUiModel(
    currentWeight = currentWeight ?: 0f,
    date = latestWeightLog?.date,
)